import React from 'react';
import { motion } from 'framer-motion';

const BackgroundShapes: React.FC = () => {
  return (
    <>
      {/* Main yellow amoeba blob - positioned behind product mockups */}
      <motion.div 
        className="absolute top-[15%] right-[10%] w-[600px] h-[600px] bg-sokoYellow/10 rounded-[42%_58%_38%_62%/42%_55%_45%_58%] z-0"
        animate={{
          borderRadius: [
            '42% 58% 38% 62% / 42% 55% 45% 58%',
            '38% 62% 48% 52% / 35% 65% 40% 60%',
            '45% 55% 40% 60% / 40% 50% 50% 60%',
            '42% 58% 38% 62% / 42% 55% 45% 58%',
          ],
          scale: [1, 1.05, 0.95, 1],
          rotate: [0, 5, -5, 0],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          repeatType: "reverse",
          ease: "easeInOut"
        }}
        style={{
          filter: 'blur(80px)'
        }}
      />
      
      {/* Teal accent blob */}
      <motion.div 
        className="absolute top-[30%] right-[20%] w-[350px] h-[350px] bg-sokoTeal/15 rounded-[62%_38%_46%_54%/49%_62%_38%_51%] z-0"
        animate={{
          borderRadius: [
            '62% 38% 46% 54% / 49% 62% 38% 51%',
            '54% 46% 38% 62% / 51% 58% 42% 49%',
            '42% 58% 52% 48% / 55% 45% 55% 45%',
            '62% 38% 46% 54% / 49% 62% 38% 51%',
          ],
          scale: [1, 0.9, 1.1, 1],
          x: [0, 20, -20, 0],
          y: [0, -30, 30, 0],
          rotate: [0, -10, 10, 0],
        }}
        transition={{
          duration: 25,
          repeat: Infinity,
          repeatType: "reverse",
          ease: "easeInOut"
        }}
        style={{
          filter: 'blur(60px)'
        }}
      />
      
      {/* Magenta small blob */}
      <motion.div 
        className="absolute bottom-[25%] right-[25%] w-[250px] h-[250px] bg-sokoMagenta/10 rounded-[38%_62%_63%_37%/41%_44%_56%_59%] z-0"
        animate={{
          borderRadius: [
            '38% 62% 63% 37% / 41% 44% 56% 59%',
            '45% 55% 52% 48% / 37% 65% 35% 63%',
            '61% 39% 42% 58% / 55% 52% 48% 45%',
            '38% 62% 63% 37% / 41% 44% 56% 59%',
          ],
          scale: [1, 1.2, 0.8, 1],
          x: [0, -15, 15, 0],
          y: [0, 20, -20, 0],
          rotate: [0, 15, -15, 0],
        }}
        transition={{
          duration: 18,
          repeat: Infinity,
          repeatType: "reverse",
          ease: "easeInOut"
        }}
        style={{
          filter: 'blur(40px)'
        }}
      />
      
      {/* Small yellow accent blob */}
      <motion.div 
        className="absolute top-[40%] left-[15%] w-[180px] h-[180px] bg-sokoYellow/8 rounded-[45%_55%_70%_30%/45%_30%_70%_55%] z-0"
        animate={{
          borderRadius: [
            '45% 55% 70% 30% / 45% 30% 70% 55%',
            '55% 45% 60% 40% / 35% 40% 60% 65%',
            '35% 65% 50% 50% / 55% 50% 50% 45%',
            '45% 55% 70% 30% / 45% 30% 70% 55%',
          ],
          scale: [1, 1.1, 0.9, 1],
          x: [0, 15, -15, 0],
          y: [0, -10, 10, 0],
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          repeatType: "reverse",
          ease: "easeInOut"
        }}
        style={{
          filter: 'blur(30px)'
        }}
      />
    </>
  );
};

export default BackgroundShapes;
